import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { HEADER_CONTROL_WRAPPER_SIZES } from './constants';

import './header_control_wrapper.scss';

const CLASS_NAME = 'header-control-wrapper';

const HeaderControlWrapper = ({
  action,
  children,
  className,
  withBorder,
  size,
  withHorizontalMargin,
  withHorizontalPadding,
}) => (
  <div
    className={classnames(CLASS_NAME, className, {
      '-with-border': withBorder,
      '-with-horizontal-margin': withHorizontalMargin,
      '-with-horizontal-padding': withHorizontalPadding,
      [`-size-${size}`]: size,
    })}
  >
    {children}
    {action}
  </div>
);

HeaderControlWrapper.propTypes = {
  action: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.string,
  withBorder: PropTypes.bool,
  withHorizontalMargin: PropTypes.bool,
  withHorizontalPadding: PropTypes.bool,
};

HeaderControlWrapper.defaultProps = {
  size: HEADER_CONTROL_WRAPPER_SIZES.DEFAULT,
  withBorder: false,
};

export default HeaderControlWrapper;
